module.exports = __webpack_public_path__ + "static/media/thumbnail.9102cd09.jpg";